var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    filter: "url(#filter0_d_1829_1753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 47.125C17 24.9646 34.9646 7 57.125 7H190.875C213.035 7 231 24.9646 231 47.125V180.875C231 203.035 213.035 221 190.875 221H57.125C34.9646 221 17 203.035 17 180.875V47.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.25 67.1875C97.25 78.2677 88.2677 87.25 77.1875 87.25C66.1073 87.25 57.125 78.2677 57.125 67.1875C57.125 56.1073 66.1073 47.125 77.1875 47.125C88.2677 47.125 97.25 56.1073 97.25 67.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3143 199.877C28.7286 200.463 28.7286 201.412 29.3143 201.998C29.9001 202.584 30.8499 202.584 31.4357 201.998L29.3143 199.877ZM83.875 147.438L84.9357 146.377C84.3499 145.791 83.4001 145.791 82.8143 146.377L83.875 147.438ZM110.625 174.188L109.564 175.248C110.15 175.834 111.1 175.834 111.686 175.248L110.625 174.188ZM170.812 114L171.873 112.939C171.287 112.354 170.338 112.354 169.752 112.939L170.812 114ZM223.252 168.561C223.838 169.146 224.787 169.146 225.373 168.561C225.959 167.975 225.959 167.025 225.373 166.439L223.252 168.561ZM31.4357 201.998L84.9357 148.498L82.8143 146.377L29.3143 199.877L31.4357 201.998ZM82.8143 148.498L109.564 175.248L111.686 173.127L84.9357 146.377L82.8143 148.498ZM111.686 175.248L171.873 115.061L169.752 112.939L109.564 173.127L111.686 175.248ZM169.752 115.061L223.252 168.561L225.373 166.439L171.873 112.939L169.752 115.061ZM57.125 8.5H190.875V5.5H57.125V8.5ZM229.5 47.125V180.875H232.5V47.125H229.5ZM190.875 219.5H57.125V222.5H190.875V219.5ZM18.5 180.875V47.125H15.5V180.875H18.5ZM57.125 219.5C35.793 219.5 18.5 202.207 18.5 180.875H15.5C15.5 203.864 34.1361 222.5 57.125 222.5V219.5ZM229.5 180.875C229.5 202.207 212.207 219.5 190.875 219.5V222.5C213.864 222.5 232.5 203.864 232.5 180.875H229.5ZM190.875 8.5C212.207 8.5 229.5 25.793 229.5 47.125H232.5C232.5 24.1361 213.864 5.5 190.875 5.5V8.5ZM57.125 5.5C34.1361 5.5 15.5 24.1361 15.5 47.125H18.5C18.5 25.793 35.793 8.5 57.125 8.5V5.5ZM95.75 67.1875C95.75 77.4393 87.4393 85.75 77.1875 85.75V88.75C89.0961 88.75 98.75 79.0961 98.75 67.1875H95.75ZM77.1875 85.75C66.9357 85.75 58.625 77.4393 58.625 67.1875H55.625C55.625 79.0961 65.2789 88.75 77.1875 88.75V85.75ZM58.625 67.1875C58.625 56.9357 66.9357 48.625 77.1875 48.625V45.625C65.2789 45.625 55.625 55.2789 55.625 67.1875H58.625ZM77.1875 48.625C87.4393 48.625 95.75 56.9357 95.75 67.1875H98.75C98.75 55.2789 89.0961 45.625 77.1875 45.625V48.625Z",
    fill: "#6D81B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1829_1753",
    x: 0.5,
    y: 0.5,
    width: 247,
    height: 247,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0117647 0 0 0 0 0.156863 0 0 0 0 0.262745 0 0 0 0.46 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1829_1753"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1829_1753",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.ad09cb058d550b6abbfa13f6ca1a7deb.svg";
export { ForwardRef as ReactComponent };